import { Navigate } from 'react-router-dom';

import { LoadingLogo } from '@/components/shared/LoadingLogo';
import { useTenantSwitcher } from '@/contexts/TenantSwitcherContext';
import { useAuth } from '@/hooks/useAuth';

interface TenantRequiredRouteProps {
  children: JSX.Element;
}

export function TenantRequiredRoute({
  children,
}: TenantRequiredRouteProps): JSX.Element {
  const { user } = useAuth();
  const { activeTenant, loadingTenant } = useTenantSwitcher();

  // If loading, show loading state
  if (loadingTenant) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingLogo size="lg" />
      </div>
    );
  }

  // If user is root and doesn't have an active tenant (after loading), redirect to tenants page
  if (user?.role === 'root' && !activeTenant && !loadingTenant) {
    return <Navigate to="/tenants" replace />;
  }

  // If user is not root but doesn't have a tenant, redirect to login
  // (This shouldn't happen due to ProtectedRoute, but just in case)
  if (user && user.role !== 'root' && !activeTenant) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
